module.exports = __webpack_public_path__ + "static/media/EarlyFemaleFigures.e6deafa4.png";